import React from 'react';
import { Link , Prompt} from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as userActions from '../../actions/usersActions';
import * as gapiAction from '../../actions/gapiActions';
import moment from 'moment';
import { confirmAlert } from 'react-confirm-alert';
import DatePicker from 'react-datepicker';
import Switch from "react-switch";
// import { toastr } from 'react-redux-toastr';
import subDays from "date-fns/sub_days"
import * as message from '../../constants/messageConstants';
import classNames from 'classnames';
import validator from './../common/validator.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as SVGICONS from '../../images/img/images';
import * as constant from '../../constants/constant';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import $ from 'jquery'
import CalendarEmailInput from '../calendar/CalendarEmailInput';
import Textarea from "react-textarea-autosize";
import { Multiselect } from "multiselect-react-dropdown";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import CustomTextField from './../miniComponents/CustomTextField'
import AddIcon from "@material-ui/icons/Add";
import ClearIcon from "@material-ui/icons/Clear";
import ErrorIcon from "@material-ui/icons/Error";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { fade,
  ThemeProvider,
  withStyles,
  makeStyles,
  createMuiTheme, } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Form, Button, Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { MultipleSelect } from "react-select-material-ui";
import FormHelperText from "@material-ui/core/FormHelperText";
import Avatar from "@material-ui/core/Avatar";
import CameraAltOutlined from "@material-ui/icons/CameraAltOutlined";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { CardHeader, InputAdornment, IconButton } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Input from "@material-ui/core/Input";
import { light } from "@material-ui/core/styles/createPalette";
import { Popover } from "antd";
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment'




const theme = createMuiTheme({
  palette: {
    primary: {
        main: "#00c8fc"
    },
  },
});

const genderList = [
    {
      value: "Male",
      label: "Male",
    },
    {
      value: "Female",
      label: "Female",
    },
  ];


const errorFontSize = {
	fontSize: 11
}
let userId = localStorage.getItem('userId')

class MySetting extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			patternOne: false,
			patternTwo: false,
			patternThree: false,
			patternFour: false,
			popoverShow: false,
			bloodGroupList: [],
			replicaBloodGroupList: [],
			image: { value: '', isValid: true, message: '' },
			gender: { value: 'Male', isValid: true, message: '' },
			userName: { value: '', isValid: true, message: '' },
			phoneNo: { value: '', isValid: true, message: '' },
			email: { value: '', isValid: true, message: '' },
			dateOfBirth: { value: null, isValid: true, message: '' },
			userId: '',
            bloodGroup: { value: '', isValid: true, message: '' },
			phoneNoCountryCode: { value: '', isValid: true, message: '' },
			//for instead reflect image change
			tabClicked: 1,
			imageCopy: '',
			file: '',
			imagePreviewUrl: '',
            defaultImageURL: '',
            
            totalErrors: false,
            editEnabled: false,
            isDisablePI: true,
			isDisableCI: true,
			isDisableES: true,
			isDisableSS: true,



      tempUploadedImage: null, 

			prompt: true,
			isDirty: false,


			viewProPicUploadDialog: false,
			removeProfileImageDialog:false,


      //change Password
      showPassword: false,
      showPassword2: false,
			currentPassword: { value: '', isValid: true, message: '' },
			password: { value: '', isValid: true, message: '' },
			cpassword: { value: '', isValid: true, message: '' },
			unsubscribe: { value: false, isValid: true, message: 'warning: we do not recommend you unsubscribe from all email notifications as appointment reminders and other important emails will not be sent.' },

			// calendar syncing
			userGoogleSyncOption: false,
			userOutlookSyncOption: false,
			useriCalendarSyncOption: false,



		}
		this.onChange = this.onChange.bind(this);
		this.updateUserProfile = this.updateUserProfile.bind(this);
		this.uploadPatientImage = this.uploadPatientImage.bind(this);
		this.onPasswordSettingChange = this.onPasswordSettingChange.bind(this);
		this.changePassword = this.changePassword.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.resetValidationStates = this.resetValidationStates.bind(this);
		this.deleteProfile = this.deleteProfile.bind(this);
		this.onrenderimage = this.onrenderimage.bind(this);
		this.deleteImage = this.deleteImage.bind(this);
		this.emailNotification = this.emailNotification.bind(this);
		this.unsubscribeEmailsViaProfile = this.unsubscribeEmailsViaProfile.bind(this);
		this.handleClickOpen = this.handleClickOpen.bind(this);
		this.handleClose = this.handleClose.bind(this)
		this.handleClose2 = this.handleClose2.bind(this)
    }
    


    enableEditMode(e) {
        console.log(e.target.className);
        if (e.target.className.includes("profile-edit-icon p-info")) {
          this.setState({ isDisablePI: false, editEnabled:true });
        }
    
        if (e.target.className.includes("calendar-edit-icon c-info")) {
          this.setState({ isDisableCI: false, editEnabled:true });
		}
		
		if (e.target.className.includes("security-settings-edit-icon s-settings")) {
			this.setState({ isDisableSS: false, editEnabled:true });
		  }
    
        
	  }
	  

	  handleClickOpen = () => {
		this.setState({ viewProPicUploadDialog: true });
	  };


	  handleClose = () => {
		this.setState({ viewProPicUploadDialog: false, tempImageObj: null });
	  };
	
	  handleClose2 = () => {
		this.setState({ removeProfileImageDialog: false });
	  };



	unsubscribeEmailsViaProfile(event) {
		var state = this.state
		state.unsubscribe = { value: event.target.checked, isValid: true, message: 'warning: we do not recommend you unsubscribe from all email notifications as appointment reminders and other important emails will not be sent.' }
		this.setState(state)
		let obj = {
			isUnsubscribe: event.target.checked,
			userId: localStorage.getItem('userId')
		}
		this.props.actions.unsubscribeEmailsViaProfile(obj);
	}
	onChange(event) {
        var state = this.state;
        console.log(event.target.value)
    state[event.target.name].value = event.target.value;
		state.isDirty = true
		if (event.target.name == 'gender') {

			if (event.target.value == 'Male') {
				this.state.defaultImageURL = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_m.png'
			}
			else {
				this.state.defaultImageURL = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_f.png'
			}
		}

		//validation code
		if (event.target.name == "userName") {
			if (event.target.value.length > 0) {
				if (!validator.isValidName(event.target.value)) {
					state[event.target.name].isValid = false;
					state[event.target.name].message = 'Please enter a valid name';
				} else {
					state[event.target.name].isValid = true;
					state.userName.message = '';
				}
			} else {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Name is Required';
			}
		}
		else if (event.target.name == "email") {
			if (event.target.value.length > 0) {
				if (!validator.isEmail(state.email.value)) {
					state[event.target.name].isValid = false;
					state[event.target.name].message = 'Not a valid email address';
					this.setState(state);
				} else {
					state[event.target.name].isValid = true;
					state[event.target.name].message = '';
				}
			} else {
				state.email.isValid = false;
				state.email.message = 'Email address is required';
				this.setState(state);
			}

		} else if (event.target.name == "bloodGroup") {
			if (event.target.value == "") {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Blood group is required';
				this.setState(state);
			} else {
				state[event.target.name].isValid = true;
				state[event.target.name].message = '';
			}
		} 
		else if (event.target.name == "phoneNo") {
			if ((event.target.value).length == 0) {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Phone number is required';
			} else if ((event.target.value).length > 10) {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Max allowed length is 10';
			} else if (!validator.isOnlyNumber(event.target.value)) {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Only numbers are allowed in phone number';
			} else if ((state.phoneNo.value).length < 10) {
				state.phoneNo.isValid = false;
				state.phoneNo.message = 'Min allowed length is 10';
			}
			else {
				state[event.target.name].isValid = true;
				state[event.target.name].message = ''
			}
        }
        



		this.setState(state);
  }
  


  handleClickShowPassword(){
    
    this.setState({
      showPassword: !this.state.showPassword
    })
  };

  
  handleClickShowPassword2(){
    
    this.setState({
      showPassword2: !this.state.showPassword2
    })
  };

   handleMouseDownPassword(event){
    event.preventDefault();
  };



	resetValidationStates() {
		var state = this.state;

		Object.keys(state).map(key => {
			if (state[key].hasOwnProperty('isValid')) {
				state[key].isValid = true;
				state[key].message = '';
			}
		});
		this.setState(state);
	}

	deleteProfile() {

		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to Delete your account? ',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						var obj = {
							userId: localStorage.getItem('userId')
						}
						this.props.actions.deletePatientAccount(obj);
					}
				},
				{
					label: 'No',
					onClick: () => { }
				}
			]
		})
	}

	handleChange(date) {
		console.log(date._d)
		this.setState({isDirty: true})
		if (date && (date != null)) {
			this.setState({ dateOfBirth: { value: date._d, message: '', isValid: true } });
            
        } else {
			this.setState({ dateOfBirth: { value: date._d, message: 'Date of birth is required', isValid: false } });
            
        }

  }
  
  

	updateUserProfile(event) {

		event.preventDefault();
        console.log('hi')
		var state = this.state;

		if (state.userName || !state.userName) {
			if (state.userName.value != undefined && state.userName.value != "") {
				if (!validator.isValidName(state.userName.value)) {
					state.userName.isValid = false;
					state.userName.message = 'Please enter a valid name';
					this.setState(state);
				} else {
					state.userName.isValid = true;
					state.userName.message = '';
					this.setState(state);
				}
			} else {
				state.userName.isValid = false;
				state.userName.message = 'Name is Required';
				this.setState(state);
			}
		} else {
			state.userName.isValid = false;
			state.userName.message = 'Name is Required';
			this.setState(state);
		}

		if (state.email || !state.email) {
			if ((state.email.value != undefined && state.email.value != "") || document.getElementById('email').value != '') {

				if (!validator.isEmail(state.email.value) && !validator.isEmail(document.getElementById('email').value)) {
					state.email.isValid = false;
					state.email.message = 'Not a valid email address';
					this.setState(state);
				} else {
					state.email.isValid = true;
					state.email.message = '';
					this.setState(state);
				}
			} else {
				state.email.isValid = false;
				state.email.message = 'Email address is required';
				this.setState(state);
			}

		} else {
			state.email.isValid = false;
			state.email.message = 'Email address is required';
			this.setState(state);
		}
		if (state.bloodGroup || !state.bloodGroup) {
			if (state.bloodGroup.value == "" || state.bloodGroup.value == undefined) {
				state.bloodGroup.isValid = false;
				state.bloodGroup.message = 'Blood group is required';
				this.setState(state);
			} else {
				state.bloodGroup.isValid = true;
				state.bloodGroup.message = '';
				this.setState(state);
			}
		} else {
			state.bloodGroup.isValid = false;
			state.bloodGroup.message = 'Blood group is required';
			this.setState(state);
		}
		// if (state.phoneNo || !state.phoneNo) {

		// 	if ((state.phoneNo.value == '' || state.phoneNo.value == undefined) && document.getElementById('phoneNo').value == '') {
		// 		state.phoneNo.isValid = false;
		// 		state.phoneNo.message = 'Phone number is required';
		// 	} else if ((state.phoneNo.value).length > 10 || document.getElementById('phoneNo').value.length > 10) {
		// 		state.phoneNo.isValid = false;
		// 		state.phoneNo.message = 'Max allowed length is 10';
		// 	} else if ((state.phoneNo.value).length < 10 || document.getElementById('phoneNo').value.length > 10) {
		// 		state.phoneNo.isValid = false;
		// 		state.phoneNo.message = 'Min allowed length is 10';
		// 	}
		// 	else if (!validator.isOnlyNumber(state.phoneNo.value) || !validator.isOnlyNumber(document.getElementById('phoneNo').value)) {
		// 		state.phoneNo.isValid = false;
		// 		state.phoneNo.message = 'Only numbers are allowed in phone number';
		// 	}
		// 	else {
		// 		state.phoneNo.isValid = true;
		// 		state.phoneNo.message = ''
		// 	}
		// }

		if (state.dateOfBirth || !state.dateOfBirth) {
			if (state.dateOfBirth.value == "" || state.dateOfBirth.value == undefined) {
				state.dateOfBirth.isValid = false;
				state.dateOfBirth.message = 'Date of birth is required';
				this.setState(state);
			} else {
				state.dateOfBirth.isValid = true;
				state.dateOfBirth.message = '';
				this.setState(state);
			}
		} else {
			state.dateOfBirth.isValid = false;
			state.dateOfBirth.message = 'Date of birth is required';
			this.setState(state);
		}


		if (this.state.userName.value != '' && this.state.phoneNo.value != '' && this.state.bloodGroup.value != '' && this.state.email.value != '' && this.state.dateOfBirth.value != '' && (this.state.phoneNo.message == '' || this.state.phoneNo.message == undefined) && (this.state.email.message == '' || this.state.email.message == undefined) && (this.state.userName.message == '' || this.state.userName.message == undefined) && (this.state.bloodGroup.message == '' || this.state.bloodGroup.message == undefined) && (this.state.dateOfBirth.message == '' || this.state.dateOfBirth.message == undefined)
			&& (this.state.gender.message == '' || this.state.gender.message == undefined) && (this.state.password.value === this.state.cpassword.value)
		) {
			let user = {
				userName: this.state.userName.value,
				gender: this.state.gender.value,
				phoneNo: this.state.phoneNo.value,
				email: this.state.email.value,
				dateOfBirth: this.state.dateOfBirth.value,
				bloodGroup: this.state.bloodGroup.value,
				phoneNoCountryCode: this.state.phoneNoCountryCode.value 
			}
      console.log("dateOfBirth", this.state.dateOfBirth);
      console.log(this.state.password.value, this.state.cpassword.value)

      if(this.state.password.value !== "" && this.state.password.value !== "" && this.state.password.message === "" && this.state.cpassword.message === ""){

        this.changePassword()
      } 
   
            this.props.actions.updateUserProfile(user);

            if(this.state.tempUploadedImage){
              this.uploadPatientImageToServer()
            }


            if (this.state.imageToBeDeleted) {
        
          
              var userObj = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
      
              if (
                !this.state.defaultImageURL.endsWith("_m.png") &&
                !this.state.defaultImageURL.endsWith("_f.png")
              ) {
                console.log(this.state.defaultImageURL)
              var delImage = {
                userId: userObj._id,
                userType: 'Patient'
              }
              this.props.actions.deleteImageProfile(delImage);
                this.setState({imageCopy:"noUserImage.jpg"})
              }
            }
         

            
            this.setState({
              password: {value:"",isValid: true,message:""},
              cpassword:{value:"",isValid: true,message:""},
              isDirty:false,
              totalErrors:false
            })
    }
    else{
      this.setState({
        totalErrors: true
      })
    }
  }
  


uploadPatientImageToServer(){
  
  this.props.actions.uploadPatientImage(this.state.patientImageObj);
  this.setState({  imagePreviewUrl:"" });
  this.handleClose();
}



	uploadPatientImage(event) {

		//To change the view immediately after uploading image 
		event.preventDefault();
		// this.resetValidationStates();
		if (event.target.name == "image") {
			if (event.target.files.length > 0) {
				if (!validator.ImageValidateFormate(event.target.files[0])) {
					toast.error('Please choose following format jpeg, jpg, png, gif')
				} else if (!validator.fileValidateSize(event.target.files[0])) {
					toast.error('File size must be less than 10 MB.')

				} else {
					let reader = new FileReader();
					let file = event.target.files[0];
					console.log(file)
					this.setState({
						image: { value: file },
						defaultImageURL: file
					})

					console.log(this.state.defaultImageURL)
					reader.onloadend = () => {
						this.setState({
							file: file,
							defaultImageURL: reader.result
						});
					}
					console.log(this.state.defaultImageURL)
					reader.readAsDataURL(file);


					this.setState({ [event.target.name]: event.target.files[0] });
					let patientObj = {
						file: event.target.files[0],
						userId: localStorage.getItem('userId')
          }
          
          this.setState({
            patientImageObj: patientObj,
            tempImageObj: URL.createObjectURL(event.target.files[0]),
            isDirty: true
          });

					// this.props.actions.uploadPatientImage(patientObj);
				}
			}

		}

  }
  
  
  uploadTempImage = () => {
    this.setState({
      tempUploadedImage: this.state.tempImageObj,
      imageToBeDeleted: false,
      isDirty: true
    });
    // toast.info("Image Uploaded");
    this.handleClose();
  };

	// **************** change function password section *********************


	onPasswordSettingChange(e) {
		var state = this.state;
		state.isDirty = true
		state[e.target.name].value = e.target.value;
		// this.resetValidationStates();
		if (e.target.name == "password") {
			this.setState({ popoverShow: true })
			if (e.target.value.length > 0) {
				if ((validator.atLeastOneLetter(state.password.value)) || (validator.atLeastOneCapitalLetter(state.password.value)) || (validator.atLeastOneNumber(state.password.value)) || (validator.atLeastEightCharacters(state.password.value))) {
					if (validator.atLeastOneLetter(state.password.value)) {
						state.patternOne = true;
					} else {
						state.patternOne = false;
					}
					if (validator.atLeastOneCapitalLetter(state.password.value)) {
						state.patternTwo = true;
					} else {
						state.patternTwo = false;
					}
					if (validator.atLeastOneNumber(state.password.value)) {
						state.patternThree = true;
					} else {
						state.patternThree = false;
					}
					if (validator.atLeastEightCharacters(state.password.value)) {
						state.patternFour = true;
					} else {
						state.patternFour = false;
					}
				} else {
					return true
				}
				if (state.patternOne && state.patternTwo && state.patternThree && state.patternFour) {
					state.password.isValid = true;
					state.password.message = '';
					state.popoverShow = false;
				} else {
					state.password.isValid = false;
					state.password.message = 'Not a valid password';
					state.popoverShow = true;
				}
			} else {
				state.patternOne = false;
				state.patternTwo = false;
				state.patternThree = false;
				state.patternFour = false;
				state.password.isValid = false;
				state.password.message = 'Password is required';
				state.popoverShow = false;
			}
		} else if (e.target.name == "cpassword") {
			if (e.target.value.length > 0) {
				if (state.password.value != state.cpassword.value) {
					state.cpassword.isValid = false;
					state.cpassword.message = 'Passwords do not match';
					this.setState(state);
				} else {
          state.cpassword.isValid = true;
          state.cpassword.message = ''
          this.setState(state)
				}
			} else {
				state.cpassword.isValid = false;
				state.cpassword.message = 'Confirm password is required';
				this.setState(state);
			}

		}
		this.setState(state);
	}
	//api calling
	changePassword() {

		var state = this.state;
		state.isDirty = true
		if (state.password || !state.password) {
			this.setState({ popoverShow: true })
			if (state.password.value.length > 0) {
				if ((validator.atLeastOneLetter(state.password.value)) || (validator.atLeastOneCapitalLetter(state.password.value)) || (validator.atLeastOneNumber(state.password.value)) || (validator.atLeastEightCharacters(state.password.value))) {
					if (validator.atLeastOneLetter(state.password.value)) {
						state.patternOne = true;
					} else {
						state.patternOne = false;
					}
					if (validator.atLeastOneCapitalLetter(state.password.value)) {
						state.patternTwo = true;
					} else {
						state.patternTwo = false;
					}
					if (validator.atLeastOneNumber(state.password.value)) {
						state.patternThree = true;
					} else {
						state.patternThree = false;
					}
					if (validator.atLeastEightCharacters(state.password.value)) {
						state.patternFour = true;
					} else {
						state.patternFour = false;
					}
				} else {
					// return true
					state.password.message = '';
					state.password.isValid = true;

				}
				if (state.patternOne && state.patternTwo && state.patternThree && state.patternFour) {
					state.password.isValid = true;
					state.password.message = '';
					state.popoverShow = false;
				} else {
					state.password.isValid = false;
					state.password.message = 'Not a valid password';
					state.popoverShow = true;
				}
			} else {
				state.patternOne = false;
				state.patternTwo = false;
				state.patternThree = false;
				state.patternFour = false;
				state.password.isValid = false;
				state.password.message = 'Password is required';
				state.popoverShow = false;
			}
		} if (state.cpassword || !state.cpassword) {
			if (state.cpassword.value.length > 0) {
				if (state.password.value != state.cpassword.value) {
					state.cpassword.isValid = false;
					state.cpassword.message = 'Passwords do not match';
					this.setState(state);
				} else {
					state.cpassword.isValid = true;
					state.cpassword.message = '';
				}
			} else {
				state.cpassword.isValid = false;
				state.cpassword.message = 'Confirm password is required';
				this.setState(state);
			}

		}
	


		if (this.state.password.value != '' && this.state.cpassword.value != ''  && (this.state.password.message == '' || this.state.password.message == undefined) && (this.state.cpassword.message == '' || this.state.cpassword.message == undefined) && (this.state.patternOne == true) && (this.state.patternTwo == true) && (this.state.patternThree == true) && (this.state.patternFour == true)) {
			if (this.state.password.value == this.state.cpassword.value) {
				let passwordObj = {
					userId: localStorage.getItem('userId'),
					newPassword: this.state.password.value
				}
				this.props.actions.changePassword(passwordObj);
				this.setState({
					currentPassword: { value: '' },
					password: { value: '' },
					cpassword: { value: '' },
					popoverShow: false
				});
        return true
			} else {
				toast.error(message.PASSWORDS_DIFFERENT);
				this.setState({
					currentPassword: { value: '' },
					password: { value: '' },
					cpassword: { value: '' },
					popoverShow: false
        });
        
        return false
			}
		}

	}

	componentWillMount() {
		let userDetail = {
			userId: localStorage.getItem('userId')
		}
		// this.setState({ ...this.state.phoneNoCountryCode, value: localStorage.getItem('calling_code') });
		
		this.props.actions.getUserDetails(userDetail);
		this.props.actions.getBloodGroupList();
		// this.props.actions.getBloodGroupList();
		this.props.gapiAction.getUsersGoogleSyncStatus({ userId: userDetail.userId });
		this.props.gapiAction.getUsersOutlookSyncStatus({ userId: userDetail.userId });
		this.props.gapiAction.getUsersiCloudSyncStatus({ userId: userDetail.userId });


	}
	componentWillReceiveProps(nextProps) {
        const user = JSON.parse(localStorage.getItem("user"))
        
    console.log("nextProps", nextProps, nextProps.userDetails)
    
    function capital_letter(str) 
    {
      str = str.split(" ");
      
      for (var i = 0, x = str.length; i < x; i++) {
       str[i] = str[i][0].toUpperCase() + str[i].substr(1);
      }
      
      return str.join(" ");
    }
		var state = this.state;
        state.userName = { value: (nextProps.userDetails.userName) ? capital_letter(nextProps.userDetails.userName) : state.userName.value },
			state.gender = { value: nextProps.userDetails.gender ? nextProps.userDetails.gender : state.gender.value },
			state.image = { value: nextProps.userDetails.image ? nextProps.userDetails.image : state.image.value },
			state.bloodGroupList = (nextProps.bloodGroupList) ? nextProps.bloodGroupList : state.bloodGroupList,
			state.replicaBloodGroupList = (nextProps.bloodGroupList) ? nextProps.bloodGroupList : state.replicaBloodGroupList,
			state.email = { value: nextProps.userDetails.email ? nextProps.userDetails.email : state.email.value, email: nextProps.userDetails.email },
			state.dateOfBirth = { value: nextProps.userDetails.dateOfBirth ? new Date(nextProps.userDetails.dateOfBirth) : this.state.dateOfBirth.value },
			state.bloodGroup = { value: nextProps.userDetails.bloodGroup ? nextProps.userDetails.bloodGroup : state.bloodGroup.value },
			state.phoneNo = { value: nextProps.userDetails.phoneNo ? nextProps.userDetails.phoneNo : state.phoneNo.value },
			state.imageCopy = nextProps.userDetails.image ? nextProps.userDetails.image : state.imageCopy,
			state.phoneNoCountryCode = { value: nextProps.userDetails.phoneNoCountryCode ? nextProps.userDetails.phoneNoCountryCode : state.phoneNoCountryCode.value },
			state.unsubscribe = { value: nextProps.userDetails.isUnsubscribe ? nextProps.userDetails.isUnsubscribe : state.unsubscribe.value }
		this.setState({ state });

		if (nextProps.specialistListAssistant && nextProps.specialistListAssistant.userName) {
			this.setState({
				specialistAssistant: nextProps.specialistListAssistant
			})

		}

		if (this.state.bloodGroupList && this.state.bloodGroupList.length == 0) {
			this.props.actions.getBloodGroupList();
		}
		if (localStorage.getItem('isClicked') === "true") {
			localStorage.removeItem('isClicked')

			this.setState({
				tabCLicked: 1
			})

		}
		if (nextProps.gapi.urlToRedirect) {
			window.location.href = nextProps.gapi.urlToRedirect
		}
		if (nextProps.gapi.put_revoke_state == null) {
			toast.info("Calendar Access Is successfully Revoked")
			console.log("REmoved Successfully", nextProps)
			// window.location.href = nextProps.gapi.urlToRedirect
		}
		if (nextProps.gapi.put_revoke_state && nextProps.gapi.put_revoke_state.data) {
			toast.info("Calendar Access Is successfully Setup")
			console.log("REmoved Successfully", nextProps)
			// window.location.href = nextProps.gapi.urlToRedirect
		}
		if (nextProps.gapi.user_google_sync_option !== null) {
			this.setState({ userGoogleSyncOption: nextProps.gapi.user_google_sync_option })
		}
		if (nextProps.gapi.user_outlook_sync_option !== null  ) {
			this.setState({ userOutlookSyncOption: nextProps.gapi.user_outlook_sync_option })
		}
		if (nextProps.gapi.user_icloud_sync_option !== null ) {
			this.setState({ useriCalendarSyncOption: nextProps.gapi.user_icloud_sync_option })
		}
	}

	deleteImage() {
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};


    if (this.state.removeProfileImageDialog === true) {
    
      this.setState({
        tempUploadedImage: "",
        tempImageObj: "",
        imageToBeDeleted: true,
        imagePreviewUrl: "deleted",
      },()=>{
        console.log(this.state.tempUploadedImage, this.state.tempImageObj, this.state.imageCopy)
      });
      // toast.info("Image Removed");

      this.handleClose();
      this.handleClose2();
    } else {
      this.setState({ removeProfileImageDialog: true });
    }


		// var delImage = {
		// 	userId: user._id,
		// 	userType: 'Patient'
		// }
		// this.props.actions.deleteImageProfile(delImage);
	}
	onrenderimage() {
		if (this.state.imageCopy == '' || this.state.imageCopy == 'noUserImage.jpg') {

			if (this.state.gender.value == 'Male') {
				this.state.defaultImageURL = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_m.png'
			}
			else {
				this.state.defaultImageURL = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_f.png'
			}
		}
		else {
			this.state.defaultImageURL = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + '/' + localStorage.getItem('userId') + '/' + this.state.imageCopy
		}
	}
	emailNotification() {
		confirmAlert({
			title: '',
			message: 'Change of email address will logout your session and send a verification to your updated email address.  Please follow the instructions in the email to reactivate your account',
			buttons: [
				{
					label: 'OK',
					onClick: () => { }
				},

			]
		})

	}

	syncWithGoogle = (data) => {
    console.log(data, this.state.userGoogleSyncOption)
		

		confirmAlert({
			title: 'Confirm',
			message: `Do you really want to ${data == true ? 'sync' : 'unsync'} Google Calendar`,
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						if (data == true){
              this.setState({ userGoogleSyncOption: true })
							this.props.gapiAction.getGapiAuth();
            }
						if (data == false) {
							let bodyData = {
								code: "",
								action: 'REVOKE'
              }
              this.setState({ userGoogleSyncOption: false })
							this.props.gapiAction.putGapiToken(bodyData, this.props);
						}
						// this.props.gapiAction.getOutlookAuth();
						// if (data == 3)
						// 	this.setState({ icloudEmailInput: true })
						// this.props.usersAction.deleteUser(userObject, userId);
					}
				},
				{
					label: 'No',
					onClick: () => {
						this.props.gapiAction.getUsersGoogleSyncStatus({ userId });
					}
				}
			]
		})



	}
	syncWithOutlook = (data) => {
		

		confirmAlert({
			title: 'Confirm',
			message: `Do you really want to ${data == true ? 'sync' : 'unsync'} appointments with  Outlook Calendar`,
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
            if (data == true)
            this.setState({ userOutlookSyncOption: true })
							this.props.gapiAction.getOutlookAuth();
						if (data == false) {
							let bodyData = {
								code: "",
								action: 'REVOKE'
              }
              this.setState({ userOutlookSyncOption: false })
							this.props.gapiAction.putOutlookToken(bodyData, this.props);
						}
						// this.props.gapiAction.getOutlookAuth();
						// if (data == 3)
						// 	this.setState({ icloudEmailInput: true })
						// this.props.usersAction.deleteUser(userObject, userId);
					}
				},
				{
					label: 'No',
					onClick: () => {
						this.props.gapiAction.getUsersOutlookSyncStatus({ userId });
					}
				}
			]
		})



	}
	
	render() {
        var countryCodeList = constant.PHONENOCOUNTRYCODE ? constant.PHONENOCOUNTRYCODE : [];
		localStorage.setItem('Gender', this.state.gender.value)
		var image = this.state.imageCopy
			? this.state.imageCopy : 'noUserImage.jpg';
		let { imagePreviewUrl } = this.state;
		var user = localStorage.getItem('user')? JSON.parse(localStorage.getItem('user')) : {};

		if (image != 'noUserImage.jpg') {
			imagePreviewUrl = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image
		} else {
			imagePreviewUrl = constant.PRODUCTION_IMAGE_URL + 'uploads/common/noUserImage.jpg';
		}
		let $imagePreview = null;
		if (!imagePreviewUrl) {
			var folderName = (image == constant.DEFAULT_USER_IMAGE) ? constant.COMMON_FOLDER : constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/';
			imagePreviewUrl = this.state.imageCopy
				? this.state.imageCopy : constant.PRODUCTION_IMAGE_URL + folderName + image;
		}
		var imagePath = "";

		if (user.image == constant.DEFAULT_USER_IMAGE) {
			imagePath = constant.PRODUCTION_IMAGE_URL + constant.COMMON_FOLDER + user.image;
		} else {
			imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		{ this.onrenderimage() }

		var bloodGroupList = this.state.bloodGroupList;
		var countryCodeList = constant.PHONENOCOUNTRYCODE ? constant.PHONENOCOUNTRYCODE : [];

        var date = new Date('2014-08-18T21:11:54');
		return (

			
		<div className="content-wrapper sp-profile">
			
		  <Prompt when={this.state.isDirty} message="There are unsaved changes, are you sure you want to exit? Clicking 'OK' will discard all changes" />
          <section className="content container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="boxMrgB proCalendar">
                  <div className="nav-tabs-custom">
                    
           <ToastContainer position="bottom-left" rtl={true} />

            
                    <Card style={{marginBottom:20}}>
                        <CardContent>
                          <div className="profile-info-page-header-body">
                            <div className="left-header-section">
                              <div className="page-header-name">Profile</div>
                              <div>
                                {" "}
                                <button
                                  className="btn btn-square btn-w-90"
                                  onClick={this.updateUserProfile}
                                >
                                  <span
                                    className="btn-text"
                                    style={{ fontSize: 16 }}
                                  >
                                    Save
                                  </span>
                                </button>
                              </div>
                            </div>
                            <div className="right-header-section">
                              {user.isVerified == 2 ? (
                                <div className="verified-icon">
                                  <img
                                    src={require("../../images/verified.png")}
                                  />
                                </div>
                              ) : (
                                ""
                              )}

                              <div
                                style={{
                                  marginTop: "auto !important",
                                  display: "flex",
                                  alignSelf: "flex-end",
                                }}
                              >
                                <a
                                  style={{ cursor: "pointer" }}
                                  target="_blank"
                                  href="https://test.medfixhealth.com/specialist-requirements"
                                >
                                  <button
                                    className="btn btn-round btn-w-90"
                                    style={{ height: "40px !important" }}
                                  >
                                    <span
                                      className="btn-text"
                                      style={{ fontSize: 16 }}
                                    >
                                      Help
                                    </span>
                                  </button>
                                </a>
                              </div>
                            </div>
                          </div>
                        </CardContent>
                      </Card>

                      {this.state.totalErrors && (
                        <div
                          className="warning-text"
                          style={{ marginBottom: 20, marginTop: 20 }}
                        >
                          <p style={{ fontSize: 16 }}>
                            <ErrorIcon
                              color="rgba(197, 91, 75, 1)"
                              style={{ fontSize: 16, marginRight: 5 }}
                            />
                            Please fix the errors below!
                          </p>
                        </div>
                      )}






							<Dialog
                            className="propic-upload-dialog"
                            onClose={this.handleClose}
                            aria-labelledby="customized-dialog-title"
                            open={this.state.viewProPicUploadDialog}
                          >
                            <DialogContent dividers>
                              <div className="propic-upload-dialog-content">
                                <div>
                                  <Avatar
                                    src={
										this.state.tempUploadedImage !== "" &&
										this.state.tempUploadedImage !== null &&
										this.state.tempUploadedImage !== undefined
										  ? this.state.tempUploadedImage
										  : this.state.tempImageObj !== undefined &&
										  this.state.tempImageObj !== null &&
										  this.state.tempImageObj !== ""
										  ? this.state.tempImageObj
										  :this.state.imagePreviewUrl === "deleted"?
										  <CameraAltOutlined/>
										  : this.state.imageCopy !==
											  "noUserImage.jpg" &&
											this.state.defaultImageURL
										  ? this.state.defaultImageURL
										  : <CameraAltOutlined/>
                                    }
                                    className="propic-icon"
                                    variant="square"
                                  ></Avatar>
                                </div>
                                <div>
                                  <button className="btn btn-square propic-upload-btn btn-w-120" style={{padding: '0px !important'}}>
                                    <input
                                      name="image"
                                      onChange={this.uploadPatientImage}
                                      onClick={(event) => {
                                        event.target.value = null;
                                      }}
                                      type="file"
                                      style={{ display: "none" }}
                                      id="avatSelect"
                                    />
                                    <label
                                      className="editimg"
                                      htmlFor="avatSelect"
                                      style={{ cursor: "pointer",width: '100%' }}
                                    >
                                      <span
                                        className="btn-text"
                                        style={{
                                          fontFamily: "roboto",
                                          fontSize: 13,
                                        }}
                                      >
                                        CHOOSE FILE
                                      </span>
                                      <span className=" editicon tooltip-custom fadeEffect"></span>
                                    </label>
                                  </button>
                                </div>
                                <div>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "Roboto",
                                    }}
                                  >
                                    A square image that will be shown on your
                                    client portal and widgets. You can upload a
                                    JPG, GIF or PNG file (file size limit is 4
                                    MB, not smaller than 130x130)
                                  </p>
                                </div>
                              </div>
                            </DialogContent>
                            <DialogActions
                              style={{ justifyContent: "flex-end" }}
                            >
                              {this.state.tempUploadedImage || this.state.tempImageObj ||
                              this.state.imageCopy !== "noUserImage.jpg" && this.state.imagePreviewUrl !=="deleted"  ? (
                                <div onClick={this.deleteImage}>
                                  <button
                                    className="propic-dialog-close-btn btn-w-120"
                                    
                                  >
                                    <span
                                      style={{
                                        fontFamily: "roboto",
                                        fontSize: 13,
                                      }}
                                      className="btn-text"
                                    >
                                      REMOVE IMAGE
                                    </span>
                                  </button>
                                </div>
                              ) : null}

                              {this.state.tempImageObj ? (
                                <div onClick={this.uploadTempImage}>
                                  <button
                                    className="propic-dialog-close-btn btn-w-120"
                                    // onClick={this.handleClose}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "roboto",
                                        fontSize: 13,
                                      }}
                                      className="btn-text"
                                      
                                    >
                                      UPLOAD
                                    </span>
                                  </button>{" "}
                                </div>
                              ) : null}

                              <div onClick={this.handleClose}>
                                <button
                                  className="propic-dialog-close-btn btn-w-120"
                                  
                                >
                                  <span
                                    style={{
                                      fontFamily: "roboto",
                                      fontSize: 13,
                                    }}
                                    className="btn-text"
                                  >
                                    CANCEL
                                  </span>
                                </button>{" "}
                              </div>
                            </DialogActions>
                          </Dialog>



                          
                          <Dialog
                            // className="propic-upload-dialog"
                            onClose={this.handleClose2}
                            aria-labelledby="customized-dialog-title"
                            className="removePropicDialog"
                            open={this.state.removeProfileImageDialog}
                          >
                            <DialogContent
                              style={{
                                height: "200px !important",
                                padding: "0px !important",
                                backgroundColor: "#f2f2f2",
                              }}
                            >
                              <div
                                className="propic-upload"
                                style={{
                                  padding: "10px !important",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: 0,
                                    padding: 10,
                                    backgroundColor: "#fff",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontFamily: "sansation_regular",
                                      fontWeight: 500,
                                      marginBottom: 0,
                                    }}
                                  >
                                    Remove Image
                                  </p>
                                </div>
                                <div className="removal-warn">
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontFamily: "Roboto",
                                      textAlign: "center",
                                    }}
                                  >
                                    Click on OK to remove the image
                                  </p>
                                </div>
                              </div>
                            </DialogContent>

                            <DialogActions
                              style={{
                                justifyContent: "flex-end",
                                backgroundColor: "#f2f2f2",
                              }}
                            >
                              <div>
                                <button
                                  className="propic-dialog-close-btn btn-w-120"
                                  onClick={this.handleClose2}
                                >
                                  <span
                                    style={{
                                      fontFamily: "roboto",
                                      fontSize: 13,
                                    }}
                                    className="btn-text"
                                  >
                                    CANCEL
                                  </span>
                                </button>{" "}
                              </div>
                              {this.state.tempUploadedImage || this.state.tempImageObj||
                              this.state.imageCopy !== "noUserImage.jpg" ? (
                                <div>
                                  <button
                                    className="propic-dialog-close-btn btn-w-120"
                                    onClick={this.deleteImage}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "roboto",
                                        fontSize: 13,
                                      }}
                                      className="btn-text"
                                    >
                                      OK
                                    </span>
                                  </button>
                                </div>
                              ) : null}
                            </DialogActions>
                          </Dialog>







                      <Row className="personal-info">
                          <Col lg={5}>
                          <div
                                  className="profile-personal-info"
                                  id="personal-information"
                                >
                                <Card>
                                    <CardContent>
                                      <Typography gutterBottom>
                                        Personal Information{" "}
                                    
                                      </Typography>

                                      <Row className="field-row">
                                        <Col lg={12}>
                                        <ThemeProvider theme={theme}>
                                          <TextField
                                            type="text"
                                            required
                                            fullWidth
                                            label="Full Name"
                                            inputProps={{ maxLength: 100 }}
                                            name="userName"
                                            value={
                                              this.state.userName
                                                ? this.state.userName.value
                                                : ""
                                            }
                                            onChange={this.onChange}
                                          /></ThemeProvider>
                                          <span
                                            className="help-block"
                                            style={{ errorFontSize }}
                                          >
                                            {this.state.userName &&
                                              this.state.userName.message}
                                          </span>
                                        </Col>
                                      </Row>

                                      <Row className="field-row">
                                        <Col lg={12}>
                                        <ThemeProvider theme={theme}>
                                          <TextField
                                            required
                                            select
                                            fullWidth
                                            // disabled={this.state.isDisablePI}
                                            name="gender"
                                            label="Gender"
                                            onChange={this.onChange}
                                            value={
                                                (this.state.gender && this.state.gender.value)
                                                  ? this.state.gender.value
                                                  : ""
                                              }
                                          >
                                                  {genderList &&
                                              genderList.map((option) => (
                                                <MenuItem
                                                  key={option.value}
                                                  value={option.value}
                                                >
                                                  {option.label}
                                                </MenuItem>
                                              ))}
                                            
                                          </TextField></ThemeProvider>
                                        </Col>
                                      </Row>

                                      <Row className="field-row">
                                        <Col lg={12}>
                                        <ThemeProvider theme={theme}>
                                          <TextField
                                            required
                                            select
                                            fullWidth
                                            // disabled={this.state.isDisablePI}
                                            name="bloodGroup"
                                            label="Blood Group"
                                            onChange={this.onChange}
                                            value={
                                                (this.state.bloodGroup && this.state.bloodGroup.value && bloodGroupList.length>0)
                                                  ? this.state.bloodGroup.value
                                                  : ""
                                              }
                                          >
                                                  {bloodGroupList &&
                                              bloodGroupList.map((option,index) => (
                                                <MenuItem
                                                  key={index}
                                                  value={option._id}
                                                >
                                                  {option.name}
                                                </MenuItem>
                                              ))}
                                            
                                          </TextField></ThemeProvider>
                                        </Col>
                                      </Row>

                                      <Row className="field-row">
                                        <Col lg={12}>
                                        

                                    
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                               disableToolbar
                                               fullWidth
                                               variant="inline"
                                               format="MM/DD/YYYY"
                                               margin="0"
                                               id="date-picker"
                                               label="Date of Birth"
                                               helperText="mm/dd/yyyy"
                                            //    disabled={this.state.isDisablePI}
                                               value={this.state.dateOfBirth.value}
                                               onChange={this.handleChange}
                                               KeyboardButtonProps = {{
                                                 'aria-label': 'change date',
                                               }}
                                                />
                                       </MuiPickersUtilsProvider>
                                        </Col>
                                      </Row>

                                      {this.state.isDisablePI ? (
                                        ""
                                      ) : (
                                        <div className="warning-text" style={{marginTop: 15}}>
                                          <p>
                                            Making changes to this section will
                                            resubmit your profile to verify any
                                            updated details. You'll still be
                                            able to continue using the platform.
                                            New changes won't appear on profile
                                            listings until the verification
                                            process completes(up to 3 weeks)
                                          </p>
                                        </div>
                                      )}
                                    </CardContent>
                                  </Card>
                                  </div>
                          </Col>

                          <Col lg={4}>
                          <div
                                  className="profile-picture"
                                  id="profile-pic"
                                  
                                >
                                  <Card >
                                    <CardContent style={{flex: 1, height: "100%",minHeight: "600px !important"}}>
                                      <Typography gutterBottom>
                                        Profile Picture
                                      </Typography>

                                      <p
                                        style={{
                                          fontSize: "12px",
                                          fontFamily: "roboto",
                                          fontWeight: 400,
                                        }}
                                      >
                                        Choose a profile picture you'd like your
                                        patients to view when they go online to
                                        book an appointment
                                      </p>
                                      

                                      <div className="profile-img-bg" >
                                       
                                        <Avatar onClick={this.handleClickOpen}>
                                          {this.state.tempUploadedImage !==
                                            "" &&
                                          this.state.tempUploadedImage !==
                                            null &&
                                          this.state.tempUploadedImage !==
                                            undefined ? (
                                            <img
                                              src={this.state.tempUploadedImage}
                                            />
                                          ) : this.state.imagePreviewUrl ===
                                            "deleted" ? (
                                            <CameraAltOutlined />
                                          ) : this.state.imageCopy !==
                                              "noUserImage.jpg" &&
                                            this.state.defaultImageURL ? (
                                            <img
                                              src={this.state.defaultImageURL}
                                            />
                                          ) : (
                                            <CameraAltOutlined />
                                          )}
                                        </Avatar>
                                      </div>
                                    </CardContent>
                                  </Card>
                                </div>
                          </Col>      

                          <Col lg={3}>
                                <div className="profile-quick-links">
                                  <Card className="quickLinks">
                                    <CardHeader title="QUICK LINKS" />
                                    <CardContent>
                                      <ul>
                                        <li>
                                          <a href="#personal-information">
                                            Personal Information
                                          </a>
                                        </li>
                                        <li>
                                          <a href="#calendar-integration">
                                            Calendar Integration
                                          </a>
                                        </li>
                                        <li>
                                          <a href="#security-settings">
                                            Security Settings
                                          </a>
                                        </li>

										<li>
                                          <a href="#email-subscriptions">
										  Email Subscriptions
                                          </a>
                                        </li>

                                        <li>
                                          <a href="#close-account">
                                            Close Account
                                          </a>
                                        </li>
                                   
                                      </ul>
                                    </CardContent>
                                  </Card>
                                </div>
                              </Col>                 

                      </Row>



                       <Row style={{marginTop: 20}} id="calendar-integration">
                         <Col lg={9} >
                             
                         <Card>
                         <CardContent>

                         <Typography gutterBottom style={{fontWeight: 600}}>
                                        Calendar Integration
                                  </Typography>
                                <div className="bottomBtn">
                                    <label htmlFor="material-switch1" style={{width: '100%',fontFamily:'roboto',fontWeight:'500',fontSize:14}}>
                                        <Switch
                                            checked={this.state.userOutlookSyncOption}
                                            // disabled={this.state.isDisableCI}
                                            onChange={() => {
                                                if (this.state.userOutlookSyncOption) {
                                                    this.syncWithOutlook(false);
                                                } else {
                                                    this.syncWithOutlook(true)
                                                }
                                                this.setState({ userOutlookSyncOption: this.state.userOutlookSyncOption })
                                            }}
                                            onColor="#86d3ff"
                                            onHandleColor="#2693e6"
                                            handleDiameter={30}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                            height={20}
                                            
                                            width={48}
                                            className="react-switch"
                                            id="material-switch1"
                                        />
                                        <span>Outlook Calendar</span>
                                    </label>
                                    {/* <Switch onChange={this.handleGoogleSwitchChange} checked={this.state.checked} /> */}
                                </div>
                                <div className="bottomBtn">
                                    <label htmlFor="material-switch2" style={{width: '100%',fontFamily:'roboto',fontWeight:'500',fontSize:14}}>
                                        <Switch
                                            checked={this.state.userGoogleSyncOption}
                                            // disabled={this.state.isDisableCI}
                                            onChange={() => {
                                                if (this.state.userGoogleSyncOption) {
                                                    this.syncWithGoogle(false);
                                                } else {
                                                    this.syncWithGoogle(true)
                                                }
                                                this.setState({ userGoogleSyncOption: this.state.userGoogleSyncOption })
                                            }}
                                            onChange={this.syncWithGoogle}
                                            onColor="#86d3ff"
                                            onHandleColor="#2693e6"
                                            handleDiameter={30}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                            height={20}
                                            width={48}
                                            className="react-switch"
                                            id="material-switch2"
                                        />
                                        <span> Google Calendar</span>
                                    </label>
                                    {/* <Switch onChange={this.handleGoogleSwitchChange} checked={this.state.checked} /> */}
                                </div>

                                </CardContent>
                                </Card>  
                             </Col>  
                           
                           </Row>                     





                           <Row style={{marginTop: 20}}  id="security-settings">
                         <Col lg={9}>
                             
                         <Card>
                         <CardContent>

                         <Typography gutterBottom style={{fontWeight: 600}}>
                                        Security Settings{" "}
                                      
                                      </Typography>

                                      <Row className="field-row">
                                        <Col lg={6}>
                                          
                                        <ThemeProvider theme={theme}>
                                          {/* <TextField
                                            type="text"
                                            required
                                            fullWidth
                                            name="email"
                                            label="Email Address"
                                            inputProps={{ maxLength: 100 }}
                                            disabled={this.state.isDisableSS}
                                            // InputProps={{ classes, disableUnderline: true }}
                                            name="userName"
                                            value={
                                              this.state.email
                                                ? this.state.email.value
                                                : ""
                                            }
                                            onChange={this.onChange}
                                          /> */}

                                            <FormControl fullWidth required>
                                            <InputLabel   htmlFor="standard-adornment-password">Email Address</InputLabel>
                                            <Input
                                              id="standard-adornment-password"
                                              required
                                              disabled={this.state.isDisableSS}
                                              fullWidth
                                              type={'text'}
                                              name="email"
                                              label="Email Address"
                                              inputProps={{ maxLength: 100 }}
                                              value={
                                              this.state.email
                                                ? this.state.email.value
                                                : ""
                                            }
                                              onChange={this.onChange}
                                              endAdornment={
                                                <InputAdornment position="end">
                                                  <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={this.handleClickShowPassword.bind(this)}
                                                    onMouseDown={this.handleMouseDownPassword.bind(this)}
                                                  >
                                                <Popover
                                          placement="rightBottom"
                                          content={"Edit Email Address"}
                                          trigger="hover"
                                          className="security-settings-edit-icon s-settings"
                                          onClick={this.enableEditMode.bind(
                                            this
                                          )}
                                        >
                                          <img
                                          style={{height:30, width: 30}}
                                            src={require("../../images/profile-edit-icon.png")}
                                            alt=""
                                          />
                                        </Popover>
                                                  </IconButton>
                                                </InputAdornment>
                                              }
                                            />
                                          </FormControl>
                                          
                                          </ThemeProvider>
                                  </Col>
                           
                                          <span
                                            className="help-block"
                                            style={{ errorFontSize }}
                                          >
                                            {this.state.userName &&
                                              this.state.userName.message}
                                          </span>
                                        
                                      </Row>
                                                

                                      <Row className="field-row">
                                        <Col lg={6}>
                                        <ThemeProvider theme={theme}>
                                       
                                           <FormControl fullWidth>
                                            <InputLabel   htmlFor="standard-adornment-password">Password *</InputLabel>
                                            <Input
                                              id="standard-adornment-password"
                                              required
                                              fullWidth
                                              type={this.state.showPassword ? 'text' : 'password'}
                                              name="password"
                                              placeholder="********"
                                              value={  this.state.password
                                                ? this.state.password.value
                                                : ""}
                                              onChange={this.onPasswordSettingChange}
                                              endAdornment={
                                                <InputAdornment position="end">
                                                  <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={this.handleClickShowPassword.bind(this)}
                                                    onMouseDown={this.handleMouseDownPassword.bind(this)}
                                                  >
                                                    {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                                  </IconButton>
                                                </InputAdornment>
                                              }
                                            />
                                          </FormControl>
                                          
                                          
                                          </ThemeProvider>
                                          <span
                                            className="help-block"
                                            style={{ errorFontSize }}
                                          >
                                            {this.state.password &&
                                              this.state.password.message}
                                          </span>
                                        </Col>
                                      </Row>

                                      <Row className="field-row">
                                        <Col lg={6}>
                                        <ThemeProvider theme={theme}>
                                          {/* <TextField
                                            type="password"
                                            required
                                            fullWidth
                                            label="Confirm Password"
                                            // type={values.showPassword ? 'text' : 'password'}
                                            inputProps={{ maxLength: 100 }}
                                            name="userName"
                                            value={
                                              this.state.cpassword
                                                ? this.state.cpassword.value
                                                : ""
                                            }
                                            onChange={this.onChange}
                                          /> */}
                                              <FormControl fullWidth required>
                                              <InputLabel   htmlFor="standard-adornment-password">Confirm Password</InputLabel>
                                              <Input
                                                id="standard-adornment-password"
                                                required
                                                fullWidth
                                                type={this.state.showPassword2 ? 'text' : 'password'}
                                                name="cpassword"
                                                placeholder="********"
                                                value={  this.state.cpassword
                                                  ? this.state.cpassword.value
                                                  : ""}
                                                onChange={this.onPasswordSettingChange}
                                                endAdornment={
                                                  <InputAdornment position="end">
                                                    <IconButton
                                                      aria-label="toggle password visibility"
                                                      onClick={this.handleClickShowPassword2.bind(this)}
                                                      onMouseDown={this.handleMouseDownPassword.bind(this)}
                                                    >
                                                      {this.state.showPassword2 ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                  </InputAdornment>
                                                }
                                              />
                                            </FormControl>
                                          
                                          
                                          
                                          </ThemeProvider>
                                          <span
                                            className="help-block"
                                            style={{ errorFontSize }}
                                          >
                                            {this.state.cpassword &&
                                              this.state.cpassword.message}
                                          </span>
                                        </Col>
                                      </Row>



                                      
                                      <Row className="field-row">
                                       
                                        <Col lg={3} >
                                        <ThemeProvider theme={theme}>
                                          <TextField
                                            required
                                            select
                                            fullWidth
                                            className=""
                                            placeholder="Country code"
                                            label="Country code"
                                            name="phoneNoCountryCode"
                                            onChange={this.onChange}
                                         
                                            value={
                                              (this.state.phoneNoCountryCode &&
                                                this.state.phoneNoCountryCode.value &&
                                              countryCodeList &&
                                              countryCodeList.length > 0)
                                                && this.state.phoneNoCountryCode.value
                                                
                                            }
                                          >
                                            {countryCodeList && countryCodeList.map((code,index)=>
																				<MenuItem key={index} value={code}>{code}</MenuItem>
																			)}
                                          </TextField>
                                          </ThemeProvider>
                                        </Col>




                                        <Col lg={3} >
                                        <ThemeProvider theme={theme}>
                                          <TextField
                                            required
                                            fullWidth
                                            className=""
                                            placeholder="Phone No."
                                            label="Phone No."
                                            name="phoneNo"
                                            onChange={this.onChange.bind(this)}
                                      
                                            value={
                                               (this.state.phoneNo &&
                                                this.state.phoneNo.value)
                                                ? this.state.phoneNo.value
                                                : ""
                                            }
                                          >
                                         
                                          </TextField>
                                          </ThemeProvider>
                                        </Col>





                                      
                                      </Row>

									  {this.state.isDisableSS ? (
                                        ""
                                      ) : (
                                        <div className="warning-text" style={{marginTop: 15}}>
                                          <p>
										  <ErrorIcon
											color="rgba(197, 91, 75, 1)"
											style={{ fontSize: 16, marginRight: 5 }}
											/> You'll receive a message with an activation link. Follow the steps to update your email.
                                          </p>
                                        </div>
                                      )}

                         </CardContent>
                                </Card>  
                             </Col>  
                           
                           </Row>   





						   <Row style={{marginTop: 20}}  id="email-subscriptions">
                         <Col lg={9}>
                             
                         <Card>
                         <CardContent>

                         <Typography gutterBottom style={{fontWeight: 600}}>
                                        Email Subscriptions{" "}
                                      
                                      </Typography>



									  <div className="bottomBtn">
                                    <label htmlFor="material-switch1" style={{width: '100%',fontFamily:'roboto',fontWeight:'500',fontSize:14}}>
                                        <Switch
                                            checked={this.state.userOutlookSyncOption}
                                            // disabled={this.state.isDisableES}
                                            onChange={() => {
                                            }}
                                            onColor="#86d3ff"
                                            onHandleColor="#2693e6"
                                            handleDiameter={30}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                            height={20}
                                            
                                            width={48}
                                            className="react-switch"
                                            id="material-switch1"
                                        />
                                        <span>Turn off all Promotional/Marketing email notifications</span>
                                    </label>
                                    {/* <Switch onChange={this.handleGoogleSwitchChange} checked={this.state.checked} /> */}
                                </div>


								<div className="bottomBtn">
                                    <label htmlFor="material-switch1" style={{width: '100%',fontFamily:'roboto',fontWeight:'500',fontSize:14}}>
                                        <Switch
                                            checked={this.state.userOutlookSyncOption}
                                            // disabled={this.state.isDisableES}
                                            onChange={() => {
                                            }}
                                            onColor="#86d3ff"
                                            onHandleColor="#2693e6"
                                            handleDiameter={30}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                            height={20}
                                            
                                            width={48}
                                            className="react-switch"
                                            id="material-switch1"
                                        />
                                        <span >Turn off all Appointment Reminders email notifications</span>
                                    </label>
                                    {/* <Switch onChange={this.handleGoogleSwitchChange} checked={this.state.checked} /> */}
                                </div>


								{this.state.isDisableES ? (
                                        ""
                                      ) : (
                                        <div className="warning-text" style={{marginTop: 15}}>
                                          <p>
										  <ErrorIcon
											color="rgba(197, 91, 75, 1)"
											style={{ fontSize: 16, marginRight: 5 }}
											/>
                                          Warning: We do not recommend you unsubscribe from all email notifications as appointment reminders and other important emails will not be sent.
                                          </p>
                                        </div>
                                      )}

                         </CardContent>
                                </Card>  
                             </Col>  
                           
                           </Row>   







						   <Row style={{marginTop: 20}}  id="close-account">
                         <Col lg={9}>
                             
                         <Card>
                         <CardContent>

                         <Typography gutterBottom style={{fontWeight: 600}}>
                                        Close Account{" "}
                                    
                                      </Typography>
                                                
											<p style={{fontSize: 14,fontFamily:'roboto',fontWeight:400}}>You'll receive an email to confirm your decision. Please note all the health records and account information will be permanently erased.</p>
											<button
											className="btn btn-square btn-w-90"
											onClick={this.deleteProfile.bind(this)}
											
											>
											<span
												className="btn-text"
												style={{ fontSize: 16 }}
											>
											Yes, Close my account!
											</span>
											</button>
                         </CardContent>
                                </Card>  
                             </Col>  
                           
                           </Row>   


						   <Row style={{marginTop: 20}}  id="close-account">
                         <Col lg={9}>
                             
                         <Card>
                         <CardContent>

                         <Typography gutterBottom style={{fontWeight: 600}}>
                                        Disclaimer{" "}
                                    
                                      </Typography>
                                                
											<p style={{fontSize: 14,fontFamily:'roboto',fontWeight:400}}>In order to maintain accurate records, all patients are required to submit personal details as they appear on official Government issued documents. The use of nicknames, pen-names, or other artistic references are not permitted. Where your personal details change, please update them on the Medfix website as soon as possible and ensure all details supplied are to the best of your knowledge at all times.
											If, owning to regional, political or other reasons you are unable to submit your details in the way Medfix are requesting them, please contact Medfix Support Team who will be happy to assist.</p>
										
                         </CardContent>
                                </Card>  
                             </Col>  
                           
                           </Row>   







                      </div></div></div></div></section>

				<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>
				</div>
			</div>

		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		userDetails: state.users.userDetails,
		bloodGroupList: state.users.bloodGroupList,
		gapi: state.gapi,

		//previous comment
		// latestPatientImage: state.users.latestPatientImage
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(userActions, dispatch),
		gapiAction: bindActionCreators(gapiAction, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(MySetting);
